import { Component, OnInit, SecurityContext } from '@angular/core';
import { TranslationService, I18nModule } from '@spartacus/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import InventoryManagementService from './../inventory-unpublished-batch/inventory-management.service'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgFor, NgClass, NgIf } from '@angular/common';
@Component({
    selector: 'app-custom-faq',
    templateUrl: './custom-faq.component.html',
    styleUrls: ['./custom-faq.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, NgFor, NgClass, NgIf, I18nModule]
})
export class CustomFAQComponent implements OnInit {

  privacyPolicyLink: any;
  termsOfUseLink: any;
  downloadResp: SafeHtml;
  lang = 'en';
  navigationData: string;
  title: any;
  desktopHelpDownload: any;
  mobileHelpDownload: any;
  DocumentLinks: any[];
  private languageChange = new BehaviorSubject(null);
  languageChange$ = this.languageChange.asObservable();

  getLanguageChange(value): any {
    this.languageChange.next(value);
  }


  constructor(private translation: TranslationService, private inventoryManagementService: InventoryManagementService, private http: HttpClient,
    private sanitizer: DomSanitizer, private router: Router, private toastService:ToastrService,
    private customprodctsevice:CustomProductsService) {
    this.translation.translate('home.myAccount.language').subscribe(res => {
      this.lang = res;
      this.getLanguageChange(res);

      let langId;
      if (this.lang === 'en') {
        langId = 'testPDF'
      } else {
        langId = 'faqDesktopMandarin'
      }
      this.callDownloadService(langId);

    });
  }

  ngOnInit(): void {
    this.translation.translate('breadcrumb.help.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
    this.translation.translate('breadcrumb.help.pageTitle').subscribe(res => {
      this.title = res;
    });
  }
  onActivate(event) {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

  }

  goToHelp() {
    this.customprodctsevice.privacyPolicyValue.subscribe((resp: any) => {
    
      if (resp.chinaInstanceCheck == 'true') {
        this.privacyPolicyLink = resp.privacyPolicy;
        this.termsOfUseLink = resp.termsOfUse;
      } else {
        this.privacyPolicyLink = 'https://www.bhp.com/privacy-policy';
        this.termsOfUseLink = 'https://www.bhp.com/terms-of-use';
      }

    })
  }

  downloadPDF(link) {
    window.open(link,"_blank");
  }

  callDownloadService(data: any) {
    this.inventoryManagementService.getFaqData(data).subscribe((resp: any) => {
      this.DocumentLinks = resp?.faqUserGuideList;
    }, err => {
      this.toastService.error('API error while fetching help links');
    });
  }

}
